import React, { useEffect, useRef } from "react";
import { Send } from "lucide-react";

interface WizardInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  isProcessing: boolean;
  isBotTyping: boolean;
}

export const WizardInput: React.FC<WizardInputProps> = ({
  value,
  onChange,
  onSubmit,
  isProcessing,
  isBotTyping,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    // Foca o input quando o componente é montado
    if (inputRef.current && !isProcessing && !isBotTyping) {
      inputRef.current.focus();
    }
  }, [isProcessing, isBotTyping]);

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <div className="border-t border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-3 md:p-4">
      <div className="flex gap-2">
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Digite sua resposta..."
          className="flex-1 px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          disabled={isProcessing || isBotTyping}
        />
        <button
          onClick={onSubmit}
          disabled={!value.trim() || isProcessing || isBotTyping}
          className="p-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center"
          aria-label="Enviar mensagem"
        >
          <Send size={20} />
        </button>
      </div>
    </div>
  );
};
